import { VueModule } from '@Foundation/utilities';
import contentPush from './code/Scripts/components/contentPush';

export default VueModule({
  components: {
    contentPush
  }
});